import type { VgsConfig } from "./vgsConfig";
import type { VgsShow } from "./vgsShow.types";

const VGS_SCRIPT_ORIGIN = "https://js.verygoodvault.com";

type ShowScriptConfig = Pick<VgsConfig, "showVersion" | "showIntegrity">;

let showLoad: Promise<VgsShow> | null = null;

function injectShowScript({
    showVersion,
    showIntegrity,
}: ShowScriptConfig): Promise<VgsShow> {
    return new Promise((resolve, reject) => {
        if (window.VGSShow) {
            resolve(window.VGSShow);
            return;
        }
        const script = document.createElement("script");
        script.src = `${VGS_SCRIPT_ORIGIN}/vgs-show/${encodeURIComponent(showVersion)}/show.js`;
        script.integrity = showIntegrity;
        script.crossOrigin = "anonymous";
        script.async = true;
        script.onload = () => {
            if (window.VGSShow) {
                resolve(window.VGSShow);
            } else {
                script.remove();
                reject(new Error("VGS Show.js loaded without VGSShow"));
            }
        };
        script.onerror = () => {
            script.remove();
            reject(new Error("Failed to load VGS Show.js"));
        };
        document.head.appendChild(script);
    });
}

export function loadVgsShow(config: ShowScriptConfig): Promise<VgsShow> {
    showLoad ??= injectShowScript(config).catch((error) => {
        showLoad = null;
        throw error;
    });
    return showLoad;
}
